<div class="container-sign-up">
    <form [formGroup]="form" class="page initial-state justify-center">
        <div class="page-box">
            <input style="visibility: hidden; height: 0px; width: 0;" type='file' id="imageUpload" accept=".png, .jpg, .jpeg" #fileInput (change)="uploadFile($event)" />
            <div class="page-form-image" style="display: flex; flex-flow: column; align-items: center; justify-content: center;" *ngIf="imageUrl">
                <img class="event-image"  [src]="imageUrl" alt="">
                <br>
                <button mat-icon-button (click)="deleteImage()">
                    <mat-icon color="accent" >delete_outline</mat-icon>
                </button>
                <br>
            </div>
                
            <div *ngIf="!imageUrl" style="text-align: center; margin-bottom: 24px;">
                <button style="border: 2px dotted; height: 120px; border-radius: 50%; text-align: center;" (click)="fileInput.click()" mat-button color="accent" >
                    Imágen de perfil
                </button>
            </div>
            
            <mat-form-field class="page-form-control" color="accent" appearance="outline">
                <mat-label>Usuario de instagram</mat-label>
                <input matInput formControlName="instagram">
            </mat-form-field>

            <mat-form-field class="page-form-control" color="accent" appearance="outline">
                <mat-label>Dirección de correo</mat-label>
                <input matInput formControlName="email" type="email" #userEmail>
            </mat-form-field>
            <mat-error *ngIf="form?.controls?.email?.errors?.email && form?.controls?.email?.touched">
                El correo electrónico no es valido.
            </mat-error>

            <mat-form-field class="page-form-control"color="accent"  appearance="outline">
                <mat-label>Repetir correo</mat-label>
                <input matInput formControlName="repeatedEmail" type="email" #repeatedMail>
            </mat-form-field>
            <mat-error *ngIf="form?.controls?.repeatedEmail?.errors?.email && form?.controls?.email?.touched">
                El correo electrónico no es valido.
            </mat-error>
    
            <mat-form-field class="page-form-control" color="accent" appearance="outline">
                <mat-label>Contraseña</mat-label>
                <input matInput formControlName="password" [type]="type" #userPwd>
                <mat-icon matSuffix (click)="onViewPassword()" *ngIf="type === 'password'">visibility</mat-icon>
                <mat-icon matSuffix (click)="onViewPassword()" *ngIf="type === 'text'">visibility_off</mat-icon>
            </mat-form-field>
            <mat-error *ngIf="form?.controls?.password?.errors && form?.controls?.password?.touched">
                La contraseña debe tener al menos 7 carácteres.
            </mat-error>
            <mat-form-field class="page-form-control" color="accent" appearance="outline">
                <mat-label>Repetir contraseña</mat-label>
                <input matInput formControlName="repeatedPassword" [type]="type" #repeatedPwd>
                <mat-icon matSuffix (click)="onViewPassword()" *ngIf="type === 'password'">visibility</mat-icon>
                <mat-icon matSuffix (click)="onViewPassword()" *ngIf="type === 'text'">visibility_off</mat-icon>
            </mat-form-field>
            <mat-error *ngIf="passwordsMatch()">
                Las contraseñas no coinciden. 
            </mat-error>
            <mat-error *ngIf="mailsMatch()">
                Las contraseñas no coinciden. 
            </mat-error>
            <mat-form-field color="accent" appearance="outline">
                <mat-label>Rango de precio</mat-label>
                <mat-select formControlName="priceRange">
                  <mat-option value="cheap">0-20</mat-option>
                  <mat-option value="middle">21-40</mat-option>
                  <mat-option value="expensive">41-1000</mat-option>
                </mat-select>
              </mat-form-field>
            <button mat-raised-button [disabled]="(userPwd?.value !== repeatedPwd?.value) || (userEmail?.value !== repeatedMail?.value) || !form?.valid || submitted" color="primary" class="page-button" (click)="submit()">Registrarme</button>
              <span class="page-text">
                ¿Ya tienes una cuenta?
                <div class="page-link" routerLink="/sign-in">Log In</div>
            </span>
        </div>
    </form>
    <img src="assets/safaera_login_image.jpg"  class="login-image" alt="a man in a concert doing rock signs">
</div>
